import React from "react";
import logo from "../../Assets/images/logo/SenicLogo.png";
import Input from "../../Components/Input/Input";
import {
    requiredValueValidator,
    minValueValidator,
    maxValueValidator,
} from "../../Validator/Rules";
import { useForm } from "../../Hooks/useForm";
import "./Login.css";
import { Link } from "react-router-dom";
import { GrHome } from "react-icons/gr";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { isLoggedIn } from "../../Hooks/isLoggedIn";
export default function Login() {
    let navigate = useNavigate();
    if (isLoggedIn()) {
        navigate("/");
    }
    const [formState, onInputHandler] = useForm(
        {
            userName: {
                value: "",
                isValid: false,
            },
            password: {
                value: "",
                isValid: false,
            },
        },
        false
    );

    function Login() {
        axiosConfig
            .post("api/auth/login", {
                userName: formState.inputs.userName.value,
                password: formState.inputs.password.value,
            })
            .then((result) => {
                localStorage.setItem("token", result.data.data.token);
                localStorage.setItem("userId", result.data.data.userId);
                localStorage.setItem("name", result.data.data.name);
                window.location.href = "/";
            })
            .catch((err) => {
                Swal.fire({
                    icon: "error",
                    title: "خطا",
                    text: "نام کاربری یا رمز عبور اشتباه است!",
                    confirmButtonText: "تلاش مجدد",
                });
            });
    }
    return (
        <>
            <div className="form-component">
                <div className="form-wrapper">
                    <h1 className="form-title">ورود به حساب</h1>
                    <div className="not-registered">
                        <h2>ثبت نام نیستید؟</h2>
                        <button>
                            <Link to="/Register">ثبت نام کنید</Link>
                        </button>
                    </div>
                    <div className="form-inputs">
                        <Input
                            element="Input"
                            id="userName"
                            placeholder="نام کاربری"
                            className="form-input"
                            type="text"
                            validitation={[
                                requiredValueValidator(),
                                minValueValidator(4),
                                maxValueValidator(25),
                            ]}
                            onInputHandler={onInputHandler}
                        />
                        <Input
                            element="Input"
                            id="password"
                            value=""
                            placeholder="رمز عبور"
                            className="form-input"
                            type="password"
                            validitation={[
                                requiredValueValidator(),
                                minValueValidator(4),
                                maxValueValidator(20),
                            ]}
                            onInputHandler={onInputHandler}
                        />
                    </div>
                    <div className="remember">
                        <input id="toggle" type="checkbox" />
                        <label for="toggle">مرا بخاطر بسپار</label>
                    </div>
                    <button
                        className={`form-btn ${formState.isFormValid ? "succes" : "error"
                            }`}
                        onClick={() => Login()}
                        disabled={!formState.isFormValid}
                    >
                        ورود
                    </button>
                    <div className="forgot-password">
                        <Link to="/forgetpassword">
                            رمز عبور را فراموش کرده ام
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}
